import {
    Typography,
    Row,
    Col,
    Card,
    Statistic,
    Select,
    Radio,
    Table,
    Space,
    message,
    DatePicker,
  } from 'antd'
  import { useState, useEffect } from 'react'
  import { getApiCountryParam, getAppUsageReportHourlyMetrics, getGameUsageHeatmap, getGameUsageOverviewChart, getGameUsageReportHourlyMetrics, getHourlyAppUsageChart, getHourlyGameUsageChart, getMostPlayedGames, getMostPlayedMazes, getTopSearchKeywords, getTopTimeSpendingUsers, getTotalUsageMetrics, getUserRetention} from 'src/api/dashboard'
  import { quickDate, chartDateType, mazeMapping, userType, dayHours, heatMapSelector } from 'src/constants'
  import { EyeOutlined } from '@ant-design/icons'
  import { Link } from 'react-router-dom'
import moment from 'moment'
import { fetchCountryProvider } from 'src/api/authen'
import { formatTimeWithSuffix } from 'src/utils/numberUtils'
import HourlyAppUsageChart from 'src/components/Charts/HourlyAppUsageChart'
import dayjs from 'dayjs'
import DailyUserCountChart from 'src/components/Charts/DailyUserCountChart'
import GameUsageHeatmap from 'src/components/Charts/GameUsageHeatmap'
import { set } from 'ramda'
  const { Title } = Typography
  const { Column } = Table
  const { RangePicker } = DatePicker
  const Dashboard = () => {
    const [usageMetricsData, setUsageMetricsData] =
        useState<TotalUsageMetricsDto | null>(null)
        const [usageMetricsloading, setUsageMetricsLoading] = useState(true)
        const [userRetentionLoading, setUserRetentionLoading] = useState(true)
    const [selectedCountryValue, setSelectedCountryValue] = useState(['ALL'])
    const [searchTypeKeyword, setSearchTypeKeyword] = useState(['game'])
    
    const [topGames, setTopGames] = useState([])
    const [topUsers, setTopUsers] = useState([])
    const [topMazes, setTopMazes] = useState([])
    const [topSearchKeyword, setTopSearchKeyword] = useState([])
    const [loading, setLoading] = useState(true)
    const [chartData, setChartData] = useState([])
    const [metricsData, setMetricsData] = useState(null)
    const [metricsDataGame, setMetricsDataGame] = useState(null)
    const [chartDataGame, setChartDataGame] = useState([])
    const [heatmapDataGame, setHeatmapDataGame] = useState([])
    const [userRetentionData, setUserRetentionData] = useState({})
    const [groupBy, setGroupBy] = useState(chartDateType[0]?.value);
    const [groupByForGame, setGroupByForGame] = useState(chartDateType[0]?.value);
     const [topUsersloading, setTopUsersLoading] = useState(true)
    const [topUsersPagination, setTopUsersPagination] = useState({
  current: 0,
  pageSize: 10,
  total: 0
});
 const [mostPlayedGamesloading, setMostPlayedGamesLoading] = useState(true)
    const [mostPlayedGamesPagination, setMostPlayedGamesPagination] = useState({
  current: 0,
  pageSize: 10,
  total: 0
});
 const [mostPlayedMazesLoading, setMostPlayedMazesLoading] = useState(true)
    const [mostSearchedKeywordPagination, setMostSearchedKeywordPagination] = useState({
  current: 0,
  pageSize: 10,
  total: 0
});
        const [gameUsageOverviewChartLoading, setGameUsageOverviewChartLoading] = useState(true)
        const [gameUsageHeatmapLoading, setGameUsageHeatmapLoading] = useState(true)
        const [dayHourFlag, setDayHourFlag] = useState<string | undefined>('day_hour');
        const handleHeatMapAxis = (e) => {
    setDayHourFlag(e.target.value)
  }
  
    const todayDate =moment().startOf('day'); 
    const defaultStartDate= moment().subtract(1, 'month').startOf('day'); 
    const initialStartDate = defaultStartDate.format('YYYY-MM-DD');
  const initialEndDate = defaultStartDate.clone().add(1, 'month').format('YYYY-MM-DD');

  const [startDate, setStartDate] = useState(
        moment().startOf('day').subtract(1, 'month')
      )
      const [endDate, setEndDate] = useState(moment().startOf('day'))
  const [selectedTimelineValue, setSelectedTimelineValue] = useState(quickDate[0]?.value);
  const [countries, setCountries] = useState([])
  const selectedAccessLevels = userType?.map(item => item.value) ?? [];
const [topSearchKeywordloading, setTopSearchKeywordloading] = useState(false)
   
  
     useEffect(() => {
        const fetchCountry = async () => {
    try {
        const data = await fetchCountryProvider();

        const fetchedCountryOptions = data.data.map((item) => ({
            label: item.countryName,
            value: item.countryCode,
        }));

        const allOption = {
            label: 'ALL', 
            value: 'ALL', 
        };

        const finalCountryOptions = [
            allOption,
            ...fetchedCountryOptions,
        ];
        
        setCountries(finalCountryOptions);
        
    } catch (error) {
        console.error('Error fetching data:', error);
    }
};
        fetchCountry()
      }, [])
  
    const _countryChange = (value) => {
     
      let countriesList;
        
            if (value === 'ALL') {
             
              countriesList = countries.map(option => option.value);
            } else {
              
              countriesList = [value];
            }
            console.log("this is being called")
      setSelectedCountryValue(countriesList)
    }
    const handleSelectedTimeRangeChange = (e) => {
      setSelectedTimelineValue(e.target.value);
      handlePeriodChange(e.target.value);
    };
    const handleGroupByChange = (e) => {
      
      setGroupBy(e.target.value);
  
    };
    const handleGroupByForGameChange = (e) => {
      setGroupByForGame(e.target.value);
      
    };
    const handlePeriodChange = (period) => {
        const range = setDateRange(period);
        if (range) {
          setStartDate(range.startDate);
          setEndDate(range.endDate);
        }
      };
      
    function setDateRange(period) {
      
    
      let startDate, endDate;
    
      switch (period) {
        case 'day':
          startDate = moment().startOf('day').format('YYYY-MM-DD');
          endDate = moment().endOf('day').format('YYYY-MM-DD');
          break;
        case 'week':
          startDate = moment().startOf('week').format('YYYY-MM-DD');
          endDate = moment().endOf('week').format('YYYY-MM-DD');
          break;
        case 'month':
          startDate = moment().startOf('month').format('YYYY-MM-DD'); 
          endDate = moment().endOf('month').format('YYYY-MM-DD');   
          break;
        case 'hour':
          startDate = moment().startOf('day').format('YYYY-MM-DD');
          endDate = moment().endOf('day').format('YYYY-MM-DD');
          break;
        case 'ONE_MONTH':
          startDate = todayDate.subtract(1,'month').format('YYYY-MM-DD');
          endDate = moment().startOf('day').format('YYYY-MM-DD');
          break;  
        case 'THREE_MONTH':
            
        startDate = todayDate.subtract(3,'month').format('YYYY-MM-DD');
        endDate = moment().startOf('day').format('YYYY-MM-DD');
          break;
        case 'SIX_MONTH':
           
        startDate = todayDate.subtract(6,'month').format('YYYY-MM-DD');
        endDate = moment().startOf('day').format('YYYY-MM-DD');
          break;
            
        default:
          console.error('Invalid period:', period);
          return null; 
      }
      return { startDate, endDate };
    }
    useEffect(() => {
      
  const fetchTopUserData = async () => {
    if (countries.length === 0) {
        return; 
    }
    setTopUsersLoading(true);
    try {
      const usersResponse = await getTopTimeSpendingUsers(
        startDate.format('YYYY-MM-DD'),
        endDate.format('YYYY-MM-DD'),
       getApiCountryParam(selectedCountryValue,countries),
        
        topUsersPagination.pageSize,
        topUsersPagination.current,
        
      );

      setTopUsers(usersResponse.data);
      setTopUsersPagination(prev => ({
        ...prev,
        total: usersResponse.total_items,
        current: usersResponse.current_page
        
      }));
    } catch (error) {
      message.error('Failed to load top users.');
    } finally {
      setTopUsersLoading(false);
    }
  };

  fetchTopUserData();
}, [startDate,endDate, selectedCountryValue, topUsersPagination.current, topUsersPagination.pageSize,countries]);

  const handleUsersTableChange = (pagination) => {
  setTopUsersPagination(prev => ({
    ...prev,
    current: pagination.current - 1, 
    pageSize: pagination.pageSize
  }));
};
//most played games
 useEffect(() => {
  const fetchMostPlayedGamesData = async () => {
    if (countries.length === 0) {
        return; 
    }
    setMostPlayedGamesLoading(true);
    try {
      const usersResponse = await getMostPlayedGames(
        startDate.format('YYYY-MM-DD'),
        endDate.format('YYYY-MM-DD'),
        getApiCountryParam(selectedCountryValue,countries),
        
        mostPlayedGamesPagination.pageSize,
        mostPlayedGamesPagination.current,

      );

      setTopGames(usersResponse.data);
      setMostPlayedGamesPagination(prev => ({
        ...prev,
        total: usersResponse.total_items,
        current: usersResponse.current_page
        
      }));
    } catch (error) {
      message.error('Failed to load most played games.');
    } finally {
      setMostPlayedGamesLoading(false);
    }
  };

  fetchMostPlayedGamesData();
}, [startDate,endDate, selectedCountryValue, mostPlayedGamesPagination.current, mostPlayedGamesPagination.pageSize,countries]);

  const handleMostPlayedGamesTableChange = (pagination) => {
  setMostPlayedGamesPagination(prev => ({
    ...prev,
    current: pagination.current - 1, 
    pageSize: pagination.pageSize
  }));
};

useEffect(() => {
  const fetchMostSearchedKeywordData = async () => {
    if (countries.length === 0) {
        return; 
    }
    setTopSearchKeywordloading(true);
    try {
      const usersResponse = await getTopSearchKeywords(
        startDate.format('YYYY-MM-DD'),
        endDate.format('YYYY-MM-DD'),
        getApiCountryParam(selectedCountryValue,countries),
        searchTypeKeyword,
        mostSearchedKeywordPagination.pageSize,
        mostSearchedKeywordPagination.current,
        
      );

      setTopSearchKeyword(usersResponse.data);
      setMostSearchedKeywordPagination(prev => ({
        ...prev,
        total: usersResponse.total_items,
        current: usersResponse.current_page
        
      }));
    } catch (error) {
      message.error('Failed to load most searched keywords.');
    } finally {
      setTopSearchKeywordloading(false);
    }
  };

  fetchMostSearchedKeywordData();
}, [selectedCountryValue,startDate,endDate, mostSearchedKeywordPagination.current, mostSearchedKeywordPagination.pageSize,countries]);

  const handleMostSearchedKeywordTableChange = (pagination) => {
  setMostSearchedKeywordPagination(prev => ({
    ...prev,
    current: pagination.current - 1, 
    pageSize: pagination.pageSize
  }));
  
};
const fetchUsageMetrics = async (searchParams) => {
    setUsageMetricsLoading(true)
    try {
      const response = await getTotalUsageMetrics(
        searchParams.startDate,
        searchParams.endDate,
        searchParams.providerCountry
      )
      setUsageMetricsData(response)
    } catch (error) {
      console.error('Error fetching data:', error)
    } finally {
      setUsageMetricsLoading(false)
    }
  }
  useEffect(() => {
   if (countries.length === 0) {
        return; 
    }
    const searchParams = {
      startDate: startDate.format('YYYY-MM-DD'),
      endDate: endDate.format('YYYY-MM-DD'),
     providerCountry: getApiCountryParam(selectedCountryValue,countries)
    }
    fetchUsageMetrics(searchParams)
  }, [selectedCountryValue, startDate, endDate,countries])

  const fetchGameOverviewChart = async (searchParams) => {
    setGameUsageOverviewChartLoading(true)
    try {
      const response = await getGameUsageOverviewChart(
        searchParams.startDate,
        searchParams.endDate,
        searchParams.providerCountry
      )
      setChartDataGame(response)
    } catch (error) {
      console.error('Error fetching data:', error)
    } finally {
      setGameUsageOverviewChartLoading(false)
    }
  }
  useEffect(() => {
   if (countries.length === 0) {
        return; 
    }
    const searchParams = {
      startDate: startDate.format('YYYY-MM-DD'),
      endDate: endDate.format('YYYY-MM-DD'),
     providerCountry: getApiCountryParam(selectedCountryValue,countries)
    }
    fetchGameOverviewChart(searchParams)
  }, [selectedCountryValue, startDate, endDate,countries])
const fetchGameHeatMap = async (searchParams) => {
    setGameUsageHeatmapLoading(true)
    try {
      const response = await getGameUsageHeatmap(
        searchParams.startDate,
        searchParams.endDate,
        searchParams.providerCountry,
        searchParams.mode,
      )
      setHeatmapDataGame(response)
    } catch (error) {
      console.error('Error fetching data:', error)
    } finally {
      setGameUsageHeatmapLoading(false)
    }
  }
  useEffect(() => {
   if (countries.length === 0) {
        return; 
    }
    const searchParams = {
      startDate: startDate.format('YYYY-MM-DD'),
      endDate: endDate.format('YYYY-MM-DD'),
     providerCountry: getApiCountryParam(selectedCountryValue,countries),
     mode: dayHourFlag,
    }
    fetchGameHeatMap(searchParams)
  }, [selectedCountryValue, startDate, endDate,countries, dayHourFlag])
 const formatValue = (val: number | string) => {
    const num = Number(val)
    if (isNaN(num)) return val

    if (num >= 1_000_000) {
      return (num / 1_000_000).toFixed(1).replace(/\.0$/, '') + 'M'
    } else if (num >= 1000) {
      return (num / 1000).toFixed(1).replace(/\.0$/, '') + 'k'
    }
    return num.toString()
  }

const fetchUserRetention = async (searchParams) => {
    setUserRetentionLoading(true)
    try {
      const response = await getUserRetention(
        searchParams.startDate,
        searchParams.endDate,
        searchParams.providerCountry
      )
      setUserRetentionData(response)
    } catch (error) {
      console.error('Error fetching data:', error)
    } finally {
      setUserRetentionLoading(false)
    }
  }
  useEffect(() => {
   if (countries.length === 0) {
        return; 
    }
    const searchParams = {
      startDate: startDate.format('YYYY-MM-DD'),
      endDate: endDate.format('YYYY-MM-DD'),
     providerCountry: getApiCountryParam(selectedCountryValue,countries)
    }
    fetchUserRetention(searchParams)
  }, [selectedCountryValue, startDate, endDate,countries])


    return (
      <div className="dashboard-wrap">
        <div className="top-content">
          <Row gutter={20} justify="end" align="middle">
            <Col flex={2}>
              <Title level={4}>Overview</Title>
            </Col>
           <Col>
                       <Select
                         value={selectedCountryValue}
                         style={{ width: 200 }}
                         onChange={_countryChange}
                         options={countries}
                       //   loading={loading}
                       >
                         {countries.map((country) => (
                           <Select.Option value={country.value} key={country.value}>
                             {country.label}
                           </Select.Option>
                         ))}
                       </Select>
                     </Col>
           
                     <Col>
                                 <RangePicker
                                   style={{ width: 300 }}
                                   allowClear={false}
                                   value={[startDate, endDate]}
                                   disabledDate={(current) =>
                                     current && current > dayjs().endOf('day')
                                   }
                                   onChange={(dates) => {
                                     if (dates) {
                                       setStartDate(dates[0])
                                       setEndDate(dates[1])
                                     } else {
                                       setStartDate(null)
                                       setEndDate(null)
                                     }
                                   }}
                                   format={'YYYY-MM-DD'}
                                 />
                               </Col>
          </Row>
        </div>
  
        

<div className="overview-content">
  <Row gutter={20} className="overall-chart" align="top"> 
   
    <Col xs={24} md={12}>
      <Card bodyStyle={{ padding: 16, height: '100%' }}> 
        <Row className="stat-grid" gutter={[16, 16]}>
          <Col xs={8}>
            <div className="stat-box">
              <Statistic
            title={<span style={{ fontSize: 18 }}>Total Users</span>}
            formatter={() => (
              <span style={{ color: '#3A63FF', fontSize: 40, fontWeight: 600 ,lineHeight:1}}>
                {formatValue(chartDataGame?.[0]?.totalUserCount || 0)}
              </span>
            )}
          />
            </div>
          </Col>

          <Col xs={8}>
            <div className="stat-box">
              <Statistic
                title={<span  style={{ fontSize: 18 }}>User Retention</span>}
               value={(userRetentionData as any)?.overallRollingRetentionRate}
                formatter={(val) => (
        <span style={{ color: '#5c6ef2', fontSize: 32, fontWeight: 600, lineHeight: 1 }}>
           
            {String(val) + '%'} 
        </span>
    )}
              />
            </div>
          </Col>
        </Row>

      
        <DailyUserCountChart data={chartDataGame} chartHeight={300} />
      </Card>
    </Col>

   
    <Col xs={24} md={12}>
      <Card bodyStyle={{ padding: 16, height: '100%' }}>
       
        <Row className="stat-grid" gutter={[16, 16]}>
          <Col xs={8}>
            <div className="stat-box">
              <Statistic
                title={<span  style={{ fontSize: 18 }}>Total Time</span>}
                value={(heatmapDataGame as any)?.metrics?.totalTime}
                formatter={(val) => (
                  <span style={{ color: '#5c6ef2', fontSize: 32, fontWeight: 600 , lineHeight: 1 }}>
                    {formatTimeWithSuffix(val)}
                  </span>
                )}
              />
            </div>
          </Col>

          <Col xs={8}>
            <div className="stat-box">
              <Statistic
                title={<span  style={{ fontSize: 18 }}>Average Time Per Day</span>}
                value={(heatmapDataGame as any)?.metrics?.medianTimePerUserPerDay}
                formatter={(val) => (
                  <span style={{ color: '#5c6ef2', fontSize: 32, fontWeight: 600, lineHeight: 1 }}>
                    {formatTimeWithSuffix(val)}
                  </span>
                )}
              />
            </div>
          </Col>

          <Col xs={8}>
            <div className="stat-box">
              <Statistic
                title={<span  style={{ fontSize: 18 }}>Average Session Per Day</span>}
                value={(heatmapDataGame as any)?.metrics?.avgSessionDuration}
                formatter={(val) => (
                  <span style={{ color: '#5c6ef2', fontSize: 32, fontWeight: 600, lineHeight: 1 }}>
                    {formatTimeWithSuffix(val)}
                  </span>
                )}
              />
            </div>
          </Col>
        </Row>

     
        <Row justify="end" style={{ marginTop: 8, marginBottom: 12 }}>
          <Radio.Group
            className="rounded-radio-group"
            size="middle"
            value={dayHourFlag}           
            onChange={handleHeatMapAxis}
          >
            {heatMapSelector.map((opt) => (
              <Radio.Button key={opt.value} value={opt.value}>
                {opt.label}
              </Radio.Button>
            ))}
          </Radio.Group>
        </Row>

        <GameUsageHeatmap data={heatmapDataGame} axisVisibility={dayHourFlag} chartHeight={300} />
      </Card>
    </Col>
  </Row>
</div>

        <div style={{ marginBottom: 20 }}>
          <Row gutter={25}  className="features-time-wrap">
                    <Col span={6}>
                      <Card>
                        <Statistic
                                title={<span style={{fontSize:'18px'}} >Casual Games</span>}

                          formatter={() => (
                            <span style={{ color: '#3A63FF',fontSize:'40px' }}>
                              {formatTimeWithSuffix(
                                usageMetricsData?.casualGameUsageDuration || 0
                              )}
                            </span>
                          )}
                        />
                      </Card>
                    </Col>
                    
                    <Col span={6}>
                      <Card>
                        <Statistic
                          title={<span style={{fontSize:'18px'}} >Treasure Hunt</span>}

                          formatter={() => (
                            <span style={{ color: '#3A63FF', fontSize: '40px' }}>
                              {formatTimeWithSuffix(
                                usageMetricsData?.treasureHunterUsageDuration || 0
                              )}
                            </span>
                          )}
                        />
                      </Card>
                    </Col>
                    <Col span={6}>
                      <Card>
                        <Statistic
                          title={<span style={{fontSize:'18px'}} >Maze</span>}
                          formatter={() => (
                            <span style={{ color: '#3A63FF', fontSize: '40px' }}>
                              {formatTimeWithSuffix(
                                usageMetricsData?.mazeUsageDuration || 0
                              )}
                            </span>
                          )}
                        />
                      </Card>
                    </Col>
                    <Col span={6}>
                      <Card>
                        <Statistic
                          title={<span style={{fontSize:'18px'}} >Survivour Zone</span>}
                          formatter={() => (
                            <span style={{ color: '#3A63FF', fontSize: '40px' }}>
                              {formatTimeWithSuffix(
                                usageMetricsData?.survivorZoneUsageDuration || 0
                              )}
                            </span>
                          )}
                        />
                      </Card>
                    </Col>
                    
                  </Row>
        </div>
  
        <div  className="bottom-content">
          <Row gutter={25}>
            <Col span={8}>
              <Card className="list-card">
                <Title level={4}>Top Games</Title>
                <Table dataSource={topGames} loading={mostPlayedGamesloading} pagination={{
    current: mostPlayedGamesPagination.current + 1,
    pageSize: mostPlayedGamesPagination.pageSize,
    total: mostPlayedGamesPagination.total,
    showSizeChanger: true
  }}
  onChange={handleMostPlayedGamesTableChange}>
                
                  <Column title="Game Name" dataIndex="gameName" key="gameName" />
                  <Column title="Play Time" dataIndex="duration" key="duration" 
                         render={(duration) => formatTimeWithSuffix(duration)} />
                  <Column
                    title="Action"
                    key="url"
                    render={() => (
                      <Space size="middle">
                        <a className="link-btn">
                          <EyeOutlined />
                        </a>
                      </Space>
                    )}
                  />
                </Table>
              </Card>
            </Col>
           
          <Col span={8}>
            <Card className="list-card">
              <Title level={4}>Top Users</Title>
              <Table dataSource={topUsers} loading={topUsersloading}
              pagination={{
    current: topUsersPagination.current + 1, 
    pageSize: topUsersPagination.pageSize,
    total: topUsersPagination.total,
    showSizeChanger: true
  }}
  onChange={handleUsersTableChange}>
                <Column title="Name" dataIndex="userName" key="userName" />
                <Column title="Game Count" dataIndex="gameCount" 
                key="gameCount" 
                               />
                <Column<{ userName: string }>
  title="Action"
  key="url"
  render={(_, record) => (
    <Space size="middle">
      <Link to={`/users/detail/${record.userName}`} className="link-btn">
        <EyeOutlined />
      </Link>
    </Space>
  )}
/>
              </Table>
            </Card>
          </Col>
           <Col span={8}>
            <Card className="list-card">
              <Title level={4}>Top Search Keyword</Title>
              <Table dataSource={topSearchKeyword} loading={topSearchKeywordloading} pagination={{
    current: mostSearchedKeywordPagination.current + 1,
    pageSize: mostSearchedKeywordPagination.pageSize,
    total: mostSearchedKeywordPagination.total,
    showSizeChanger: true
  }}
  onChange={handleMostSearchedKeywordTableChange}>
                
                <Column title="Name" dataIndex="searchTerm" key="searchTerm"/>
                <Column title="Search Count" dataIndex="searchTermCount" 
                key="searchTermCount" 
                
                />
                <Column
                  title="Action"
                  key="url"
                  render={() => (
                    <Space size="middle">
                      <a className="link-btn">
                        <EyeOutlined />
                      </a>
                    </Space>
                  )}
                />
              </Table>
            </Card>
          </Col>
          </Row>
        </div>
      </div>
    )
  }
  
  export default Dashboard
  